/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuColorSelect_itemSearch = {
    readonly appliedFilters: ReadonlyArray<{
        readonly name: string | null;
        readonly values: ReadonlyArray<{
            readonly urlLabel: string | null;
        } | null> | null;
    } | null> | null;
    readonly " $refType": "SbSharedRefineMenuColorSelect_itemSearch";
};
export type SbSharedRefineMenuColorSelect_itemSearch$data = SbSharedRefineMenuColorSelect_itemSearch;
export type SbSharedRefineMenuColorSelect_itemSearch$key = {
    readonly " $data"?: SbSharedRefineMenuColorSelect_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuColorSelect_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuColorSelect_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "appliedFilters",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParam",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "values",
          "storageKey": null,
          "args": null,
          "concreteType": "SearchBrowseParsedParamValue",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "urlLabel",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'e9df615d4c63b21fa690da2cca8c94cb';
export default node;
